var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',{staticClass:"d-flex align-items-center justify-content-center p-3 bg-light",staticStyle:{"flex-direction":"column"}},[_c('a',{staticClass:"mb-2",attrs:{"href":_vm.noviposUrl,"target":"_blank"}},[_c('b-img',{staticClass:"novipos-logo",attrs:{"src":require('@base/assets/images/novipos-logo.png')}})],1),_c('span',{staticClass:"pre-wrap",domProps:{"innerHTML":_vm._s(_vm.$t('pages.home.footer.text', {
      currentYear: new Date().getFullYear(),
      appName: _vm.appName,
    }))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }